import React from 'react';
import { Badge } from '@/components/ui/badge';

const STAGES = {
  WAITING: ['Waiting for Greige Storage', 'bg-amber-100 text-amber-800'],
  IN_PROGRESS: ['In progress', 'bg-sky-100 text-sky-800'],
  CLOSED: ['Closed', 'bg-emerald-100 text-emerald-800'],
  COMPLETED: ['Completed in SFG', 'bg-emerald-600 text-white'],
  CANCELLED: ['Cancelled', 'bg-gray-100 text-gray-600'],
  OPEN: ['To pick', 'bg-amber-100 text-amber-800'],
  PICKING: ['Picking', 'bg-orange-100 text-orange-800'],
  PICKED: ['Picked · ready to transfer', 'bg-indigo-100 text-indigo-800'],
  TRANSFERRED: ['Transferred', 'bg-emerald-100 text-emerald-800'],
  REJECTED: ['Rejected by Processing', 'bg-rose-100 text-rose-800'],
};

export const JoBadge = ({ status, testId }) => {
  const [label, cls] = STAGES[status] || [status, 'bg-gray-100 text-gray-700'];
  return <Badge className={`${cls} border-0 font-medium whitespace-nowrap`} data-testid={testId}>{label}</Badge>;
};

export const stageLabel = (status) => (STAGES[status] || [status])[0];

export const ROUTES = [['INHOUSE', 'Inhouse route', 'Folding → Damage → Pressing → Assortment Packing → SFG Storage'],
  ['FLEXI', 'Flexi route', 'Flexi Section → Flexi job order → Flexi box → SFG Storage']];
export const routeLabel = (r) => (ROUTES.find(([v]) => v === (r || 'INHOUSE')) || ROUTES[0])[1];

/** Where most of the order's pieces are now (list Stage column). */
export const StageCell = ({ t, testId }) => {
  const c = t?.current;
  if (!c) return <span className="text-gray-400" data-testid={testId}>—</span>;
  return (
    <div className="min-w-[150px]" data-testid={testId}>
      <div className={`text-sm font-medium whitespace-nowrap ${c.stuck ? 'text-amber-700' : 'text-gray-900'}`}>{c.label} · {fmtN(c.pcs)} pcs{c.stuck ? ' · stuck' : ''}</div>
      <div className="text-[11px] text-gray-500 whitespace-nowrap">{fmtN(t.done_pcs)} in SFG · {fmtN(t.in_progress_pcs)} in progress{t.lost_pcs ? ` · ${fmtN(t.lost_pcs)} lost` : ''}</div>
    </div>
  );
};

export const OverdueBadge = ({ days, testId }) => (days > 0 ? (
  <Badge className="bg-rose-600 text-white border-0 font-semibold whitespace-nowrap" data-testid={testId}>Overdue · {days}d</Badge>
) : null);

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');
export const fmtDay = (ymd) => (ymd ? new Date(`${ymd}T00:00:00`).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const fmtN = (n) => Number(n || 0).toLocaleString('en-IN');

const TONES = { ordered: 'text-gray-900', slips: 'text-sky-700', sent: 'text-indigo-700', received: 'text-emerald-700', balance: 'text-amber-700', jobber: 'text-rose-700' };

/** Number chips: ordered · on pick slips · transferred · received · balance to send (· with jobbers). */
export const JoChips = ({ o, testPrefix = 'jo', withJobber = false }) => {
  const items = [['Ordered', o.ordered_pcs, 'ordered'], ['On pick slips', o.on_slips_pcs, 'slips'], ['Transferred', o.transferred_pcs, 'sent'],
    ['Received back', o.received_pcs, 'received'], ['Balance to send', o.balance_to_send, 'balance']];
  if (withJobber) items.push(['With jobbers', o.with_jobber_pcs, 'jobber']);
  return (
    <div className={`grid grid-cols-2 sm:grid-cols-3 ${withJobber ? 'lg:grid-cols-6' : 'lg:grid-cols-5'} gap-2`}>
      {items.map(([label, n, k]) => (
        <div key={k} className="rounded-lg border border-[#E5DFD0] bg-white px-3 py-2">
          <div className="text-[11px] uppercase tracking-wide text-gray-500">{label}</div>
          <div className={`text-xl font-bold tabular-nums ${TONES[k]}`} data-testid={`${testPrefix}-chip-${k}`}>{fmtN(n)}</div>
        </div>
      ))}
    </div>
  );
};
